import React from 'react';

function CanStoreLogin(): JSX.Element {
	return (
		<section>
			<h1>CanStoreLogin</h1>
		</section>
	);
}

export default CanStoreLogin;
